// extracted by mini-css-extract-plugin
export default {"title":"AddBooking_title__sGFa9","button":"AddBooking_button__RNoSx"};